import api from './api'

/**
 * List all users on the Forge access list.
 * @returns {Promise<Array<{email: string, grantedBy: string, grantedAt: string}>>}
 */
export const listForgeAccess = async () => {
  const response = await api.get('/api/forge/access')
  return response.data
}

/**
 * Grant Forge access to a user.
 * @param {string} email
 * @returns {Promise<{status: string, email: string}>}
 */
export const grantForgeAccess = async (email) => {
  const response = await api.post('/api/forge/access', { email })
  return response.data
}

/**
 * Revoke Forge access from a user. Email is URL-encoded in the query string.
 * @param {string} email
 * @returns {Promise<{status: string, email: string}>}
 */
export const revokeForgeAccess = async (email) => {
  const response = await api.delete('/api/forge/access', { params: { email } })
  return response.data
}
